"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const close_svg_1 = __importDefault(require("@components/icons/close.svg"));
const common_1 = require("@components/common");
const react_dnd_1 = require("react-dnd");
const TagWrapper = (0, styled_components_1.default)(common_1.Flex).attrs({
    align: 'center',
    justify: 'center',
}) `
  border: 1px solid #ccc;
  border-radius: 50px;
  height: 50px;
  width: fit-content;
  padding: 0 15px;
  line-height: 1;
  box-sizing: border-box;
  transform: translate(0, 0);
  background: #fff;
  cursor: grab;
`;
const ExerciseTag = ({ children, id, moveCard, findCard, onRemove }) => {
    const originalIndex = findCard(id).index;
    const [{ isDragging }, drag] = (0, react_dnd_1.useDrag)(() => ({
        type: 'tag',
        item: { id, originalIndex },
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
        end: (item, monitor) => {
            const { id: droppedId, originalIndex } = item;
            const didDrop = monitor.didDrop();
            if (!didDrop) {
                moveCard(droppedId, originalIndex);
            }
        },
    }), [id, moveCard]);
    const [, drop] = (0, react_dnd_1.useDrop)(() => ({
        accept: 'tag',
        hover({ id: draggedId }) {
            if (draggedId !== id) {
                const { index: overIndex } = findCard(id);
                moveCard(draggedId, overIndex);
            }
        },
    }), [moveCard, findCard]);
    const handleRemove = (0, react_1.useCallback)(() => {
        onRemove({ id });
    }, [id, originalIndex]);
    const draggingStyles = isDragging ? { opacity: 0, cursor: 'grabbing' } : {};
    return (react_1.default.createElement(TagWrapper, { ref: (node) => drag(drop(node)), style: draggingStyles },
        children,
        react_1.default.createElement(common_1.Box, { ml: "10px", style: { cursor: 'pointer' }, w: "10px", onClick: handleRemove },
            react_1.default.createElement(close_svg_1.default, null))));
};
exports.default = ExerciseTag;
